import {getSignOutUrl} from '#util';

export type HeaderLink = {
  children: string;
  featureFlag?: string;
  hasSeparator?: boolean;
  hideOnDesktop?: boolean;
  href?: string;
  rel?: string;
  requiresAnon?: boolean;
  requiresAuth?: boolean;
  requiresActiveSubscription?: boolean;
  requiresMembership?: boolean;
  memberLock?: boolean;
  subMenu?: HeaderLink[];
  target?: string;
};

export const unauthenticatedNavLinks: HeaderLink[] = [
  {href: '/shop/pages/our-science', children: 'Science'},
  {href: '/shop/collections/supplements', children: 'Supplements'},
  {href: '/shop/blogs/learn', children: 'Blog'},
  {href: '/shop/collections', children: 'Shop'},
];

export const navLinks: HeaderLink[] = [
  {children: "What's New", href: '/dashboard'},
  {children: 'My TallyAge™', href: '/mytallyage'},
  {children: 'Action Plan', href: '/actionplan', memberLock: true},
  {children: 'Blog', href: '/shop/blogs/learn'},
  {children: 'Shop', href: '/shop/collections'},
];

export const miscLinks: HeaderLink[] = [
  {
    href: '/shop/pages/referrals',
    children: 'Refer a Friend',
  },
  {href: '/profile', children: 'Account', requiresAuth: true},
  {
    children: 'Help Center',
    href: process.env.NEXT_PUBLIC_HELP_CENTER_URL || '',
    rel: 'noreferrer noopener',
    target: '_blank',
  },
  {
    children: 'Contact Us',
    href: process.env.NEXT_PUBLIC_CONTACT_URL || '',
    rel: 'noreferrer noopener',
    target: '_blank',
  },
  {
    children: 'Log Out',
    hasSeparator: true,
    href: getSignOutUrl(),
    requiresAuth: true,
  },
];
